import {
    Icon,
    IconButton
} from '@mui/material';
import { MRT_ColumnDef } from 'material-react-table';
import { useEffect, useMemo, useState } from 'react';
import { Route, Routes, useNavigate, useParams } from 'react-router-dom';
import { TABLE_FILTER } from '../../../_const/tableFilter.const';
import { handleErrorResponse } from '../../../_helpers/handleResponse.helper';
import { StandardTablePanel } from '../../../_components/panel/standardTable.panel';
import { CentreContactsManageDrawer } from './centre-contactManageDrawer';
import { appointmentsService } from '../../../_services/appointments.service';
import { getDateString } from '../../../_helpers/dateTime.helper';
import { CentreAppointmentsManageDrawer } from './centre-appointmentsManageDrawer';



export const CentreAppointmentsPanel = () => {
    const { centreId } = useParams<{ centreId: string }>();
    const [data, setData] = useState<any>({ items: [], count: 10 });
    const [filter, setFilter] = useState<any>({ ...TABLE_FILTER, pageSize: "10", orderBy: "date" });
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();

    const fetchData = async () => {
        if (!centreId) return;
        setIsLoading(true);
        return await appointmentsService.getAllAppointmentsForCentre(centreId, filter)
            .then(
                json => {
                    setData(json);
                }, handleErrorResponse)
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchData();
    }, [centreId, filter]);

    const columns = useMemo<MRT_ColumnDef<any>[]>(
        () => [
            {
                id: 'actions',
                header: '',
                size: 5,
                enableSorting: false,
                enableColumnFilter: false,
                enableColumnActions: false,
                Cell: ({ row }) => (
                    <IconButton
                        color="primary"
                        onClick={() => { navigate("Appointment/Manage/" + row.original.id) }}>
                        <Icon>edit</Icon>
                    </IconButton>
                ),
            },
            {
                accessorKey: 'date',
                header: 'Date',
                Cell: ({ row }) => (
                    <>{!!row.original.date ? getDateString(row.original.date) : ""}</>
                ),
                enableSorting: false,
                enableColumnFilter: false,
                enableColumnActions: false,
                size: 75,
            },
            {
                accessorKey: 'detailsOfAppointments',
                header: 'Details',
                enableSorting: false,
                enableColumnFilter: false,
                enableColumnActions: false,
                Cell: ({ row }) => (
                    <div
                        dangerouslySetInnerHTML={{
                            __html: row.original.detailsOfAppointments,
                        }}
                    />
                ),
            },
            {
                accessorKey: 'clientName',
                header: 'Client',
                enableSorting: false,
                enableColumnFilter: false,
                enableColumnActions: false,

            },
        ],
        []
    );

    return (
        <>
            <StandardTablePanel
                title="Appointments"
                buttons={[
                    { icon: "add", onClick: () => { navigate("Appointment/Create"); } },
                ]}

                columns={columns}
                data={data}
                filter={filter}
                setFilter={setFilter}
                loading={isLoading}
                enableBottomToolbar
            />


            <Routes>
                <Route path="Appointment/Create" element={<CentreAppointmentsManageDrawer centreId={centreId!} onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate("") }} />} />
                <Route path="Appointment/Manage/:id" element={<CentreAppointmentsManageDrawer centreId={centreId!} onSave={() => { navigate(""); fetchData(); }} onClose={() => { navigate("") }} />} />
            </Routes>

        </>
    );
};